export const environment = {
  name: 'dev',
  firebase: {
    apiKey: 'AIzaSyCBoigYs-EX0CYxoQMCYcZBUp9EtjC3yUI',
    authDomain: 'dev-open-eat.firebaseapp.com',
    projectId: 'dev-open-eat',
    storageBucket: 'dev-open-eat.appspot.com',
    messagingSenderId: '992794764960',
    appId: '1:992794764960:web:287fcaa4db690fc46d0bc5',
    measurementId: 'G-DJ3HX8QMVE',
  },
  recaptchaEnterpriseSiteKey: '6Lf__gQuAAAAAMw1jeqHCAU_dVV4pOqUtQ9S-fGZ',
  axeptioSettings: {
    clientId: '6745d2f9d758012e2226f255',
    cookiesVersion: 'site commercant openeat-fr_DEV',
  },
};
